import { hasActiveObservations as t } from "./ghl-ui.es1689.js";
import { hasSkippedObservations as e } from "./ghl-ui.es1690.js";
import { deliverResizeLoopError as i } from "./ghl-ui.es1691.js";
import { broadcastActiveObservations as s } from "./ghl-ui.es1692.js";
import { gatherActiveObservationsAtDepth as o } from "./ghl-ui.es1693.js";
var n = function() {
  var r = 0;
  for (o(r); t(); )
    r = s(), o(r);
  return e() && i(), r > 0;
};
export {
  n as process
};
